import React from "react";
import "../assets/ImagenesSeleccionadas.css";
import predet from "../placeholder.jpg";
import { FaDownload } from "react-icons/fa";

const ImagenesSeleccionadas = ({
  imagenSeleccionada,
  imagenGenerada,
  loading,
}) => {
  // Elige la imagen final o el placeholder
  const src = imagenGenerada || imagenSeleccionada || predet;

  const handleDownload = async () => {
    if (!imagenGenerada) return;
    try {
      const response = await fetch(imagenGenerada);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "mixoutfit_res.png";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Error descargando la imagen:", err);
    }
  };

  return (
    <aside className="imagenes">
      <div className="contenedor-imagen">
        <div className="image-wrapper">
          {/* Overlay de carga siempre encima */}
          {loading && (
            <div className="overlay">
              <div className="spinner"></div>
            </div>
          )}

          {/* Imagen */}
          <img
            src={src}
            alt="Imagen seleccionada"
            className={`imagen-mostrada ${!src ? "imagen-stock" : ""}`}
            style={{ pointerEvents: loading ? "none" : "auto" }}
          />

          {/* Botón de descarga */}
          {imagenGenerada && (
            <button
              className="download-button"
              onClick={handleDownload}
              disabled={loading}
              style={{ cursor: loading ? "not-allowed" : "pointer" }}
            >
              <FaDownload />
            </button>
          )}
        </div>
      </div>
    </aside>
  );
};

export default ImagenesSeleccionadas;
